/* tslint:disable */
/* eslint-disable */
/**
 * Product App Microservice
 * Product App Tier
 *
 * The version of the OpenAPI document: 1.7.8-SNAPSHOT
 * Contact: akrivitzky@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Deprecated values: A/O and B/O
 * @export
 */
export const DerivedAvailabilityStatus = {
    InStock: 'IN_STOCK',
    OutOfStock: 'OUT_OF_STOCK',
    LowStock: 'LOW_STOCK',
    Nya: 'NYA',
    AO: 'A/O',
    BO: 'B/O',
    Ao: 'AO',
    Bo: 'BO',
    Nla: 'NLA',
    Naw: 'NAW'
} as const;
export type DerivedAvailabilityStatus = typeof DerivedAvailabilityStatus[keyof typeof DerivedAvailabilityStatus];


export function instanceOfDerivedAvailabilityStatus(value: any): boolean {
    for (const key in DerivedAvailabilityStatus) {
        if (Object.prototype.hasOwnProperty.call(DerivedAvailabilityStatus, key)) {
            if (DerivedAvailabilityStatus[key as keyof typeof DerivedAvailabilityStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DerivedAvailabilityStatusFromJSON(json: any): DerivedAvailabilityStatus {
    return DerivedAvailabilityStatusFromJSONTyped(json, false);
}

export function DerivedAvailabilityStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DerivedAvailabilityStatus {
    return json as DerivedAvailabilityStatus;
}

export function DerivedAvailabilityStatusToJSON(value?: DerivedAvailabilityStatus | null): any {
    return value as any;
}

export function DerivedAvailabilityStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DerivedAvailabilityStatus {
    return value as DerivedAvailabilityStatus;
}

